import { useEffect } from 'react';
import { Events, tracking } from '@lib/events';
import { AllAppointmentsLink } from './AllAppointmentsLink/AllAppointmentsLink';
import { TimeBlockCard } from './TimeBlockCard';
import { useAppointmentTimePreference } from './context/useAppointmentTimePreference';

export function TimeBlockSelector() {
  const { groupedAvailabilitiesByTimeBlock } = useAppointmentTimePreference();
  const { now, today, tomorrow } = groupedAvailabilitiesByTimeBlock;

  const hasNow = Boolean(now.length);
  const hasToday = Boolean(today.length);
  const hasTomorrow = Boolean(tomorrow.length);

  useEffect(() => {
    tracking.trackEvent(Events.VIEW_TIME_BLOCKS, {
      availableTimeBlocks: {
        now: hasNow,
        today: hasToday,
        tomorrow: hasTomorrow,
      },
    });
  }, [hasNow, hasToday, hasTomorrow]);

  return (
    <div className="flex flex-1 flex-col">
      <div className="grid gap-sp-2">
        {hasNow && <TimeBlockCard timeBlock="now" />}

        {hasToday && <TimeBlockCard timeBlock="today" />}

        {hasTomorrow && <TimeBlockCard timeBlock="tomorrow" />}

        <AllAppointmentsLink />
      </div>
    </div>
  );
}
